import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    TextField, Stack, Alert
} from '@mui/material';
import { api } from '../api';

export const ChangePasswordDialog = ({ open, onClose, userToEdit, isAdminMode = false }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSave = async () => {
        setError('');
        setSuccess('');

        if (newPassword !== confirmPassword) {
            return setError('New passwords do not match.');
        }
        if (newPassword.length < 6) {
            return setError('New password must be at least 6 characters long.');
        }

        try {
            let response;
            if (isAdminMode) {
                // Admin is resetting a user's password (this is already working)
                response = await api.put(`/users/${userToEdit.id}/change-password`, { newPassword });
            } else {
                // --- THIS IS THE FIX (Part 2) ---
                // User is changing their own password via the new, secure route.
                response = await api.put('/users/me/password', { currentPassword, newPassword });
            }
            setSuccess(response.data.message);
            setTimeout(() => {
                handleClose();
            }, 2000);
        } catch (err) {
            setError(err.response?.data?.message || 'An unexpected error occurred.');
        }
    };

    const handleClose = () => {
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setError('');
        setSuccess('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
            <DialogTitle>{isAdminMode ? `Reset Password for ${userToEdit?.email}` : 'Change Your Password'}</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 2 }}>
                    {!isAdminMode && (
                        <TextField
                            type="password"
                            label="Current Password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            fullWidth
                            autoFocus
                        />
                    )}
                    <TextField
                        type="password"
                        label="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        fullWidth
                        autoFocus={isAdminMode}
                    />
                    <TextField
                        type="password"
                        label="Confirm New Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        fullWidth
                    />
                    {error && <Alert severity="error">{error}</Alert>}
                    {success && <Alert severity="success">{success}</Alert>}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSave} variant="contained">Save Changes</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ChangePasswordDialog;